// extracted by mini-css-extract-plugin
export default {"childs":"configProducts_childs__FSbYK","connector":"configProducts_connector__ZNdrS","countItems":"configProducts_countItems__RZfS3","footer":"configProducts_footer__1BKDZ"};